import { EMarkAsViewedActionType, IMarkAsViewedSucceedPayload } from './types';
import {
  markAsViewed as browserMarkAsViewed,
  isAvailable as isViewedClustersAvailable,
} from '../../../../browser/utils/viewedClusters';
import {
  fetchMarkOffersAsViewed,
  TMarkOffersAsViewedResponse,
} from '../../repositories/viewed-offers/v1/mark-offers-as-viewed';
import { TFeature } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { ResponseError } from '../../utils/errors/ResponseError';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const setStatusLoading = actionGenerator<EMarkAsViewedActionType.Loading>(EMarkAsViewedActionType.Loading);
const setStatusSucceed = actionGenerator<EMarkAsViewedActionType.Succeed, IMarkAsViewedSucceedPayload>(
  EMarkAsViewedActionType.Succeed,
);
const setStatusFailed = actionGenerator<EMarkAsViewedActionType.Failed>(EMarkAsViewedActionType.Failed);

interface IMarkAsViewedParameters {
  feature: TFeature;
  /** cianId открытого объявления: просмотренным помечается только оно, а не вся фича (у мультипина их до десятков) */
  offerId: number;
  precision: number;
  isDetailed: boolean;
}

export function markAsViewed({
  feature,
  offerId,
  precision,
  isDetailed,
}: IMarkAsViewedParameters): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi } = context;
    const { id: featureId } = feature;

    dispatch(setStatusLoading());

    if (!isDetailed) {
      if (isViewedClustersAvailable()) {
        browserMarkAsViewed(offerId);
        dispatch(setStatusSucceed({ featureId, offerId, precision }));
      }

      return;
    }

    try {
      const markAsViewedResponse: TMarkOffersAsViewedResponse = await fetchMarkOffersAsViewed({
        httpApi,
        parameters: {
          fromPin: true,
          offersId: [offerId],
        },
      });

      if (markAsViewedResponse.statusCode !== 200 && markAsViewedResponse.statusCode !== 204) {
        throw new ResponseError({
          domain: 'viewed#markAsViewed',
          message: markAsViewedResponse.response.message,
          details: {
            error: markAsViewedResponse.response.errors,
          },
        });
      }

      dispatch(setStatusSucceed({ featureId, offerId, precision }));
    } catch (error) {
      const { logger } = context;

      logger.error(error);

      dispatch(setStatusFailed());
    }
  };
}
